import { forwardRef } from 'react'
import { cn } from '@/lib/utils'
import { ChevronDown } from 'lucide-react'

type TacticalSelectProps = React.SelectHTMLAttributes<HTMLSelectElement> & {
  label?: string
  error?: string
  options: { value: string; label: string }[]
  placeholder?: string
}

export const TacticalSelect = forwardRef<HTMLSelectElement, TacticalSelectProps>(
  ({ className, label, error, options, placeholder, id, ...rest }, ref) => {
    const selectId = id || label?.toLowerCase().replace(/\s+/g, '-')

    return (
      <div className="space-y-1">
        {label && (
          <label
            htmlFor={selectId}
            className="block text-xs text-muted-foreground/70"
          >
            {label}
          </label>
        )}
        <div className="relative">
          <select
            ref={ref}
            id={selectId}
            className={cn(
              'w-full bg-transparent border-b border-border/40 py-1.5 text-sm text-foreground',
              'appearance-none cursor-pointer',
              'focus:border-muted-foreground focus:outline-none focus:ring-0',
              'transition-colors duration-200',
              error && 'border-destructive/50',
              className
            )}
            {...rest}
          >
            {placeholder && (
              <option value="" disabled className="bg-background">
                {placeholder}
              </option>
            )}
            {options.map((option) => (
              <option key={option.value} value={option.value} className="bg-background">
                {option.label}
              </option>
            ))}
          </select>
          <ChevronDown className="absolute right-0 top-1/2 -translate-y-1/2 h-4 w-4 text-muted-foreground/50 pointer-events-none" />
        </div>
        {error && <p className="text-xs text-destructive mt-1">{error}</p>}
      </div>
    )
  }
)

TacticalSelect.displayName = 'TacticalSelect'
